// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu_white .menu__button-item {
  background-color: rgba(var(--white));
}
.menu__button {
  display: block;
  cursor: pointer;
  transform-origin: 1rem 0.7rem;
  float: left;
  outline: 0;
  border: 0;
  background: none;
}
.menu__button-item {
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  display: block;
  width: 1.1875rem;
  height: 0.125rem;
  margin-bottom: 0.25rem;
  border-radius: 0.125rem;
  background-color: rgba(var(--grey-800));
}
.menu__button-item:last-child {
  margin-bottom: 0;
}
.menu__side {
  position: fixed;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  z-index: 999999;
  top: 0;
  bottom: 0;
  left: -100%;
  background-color: rgba(var(--grey-800));
  transition: all 0.5s;
  width: 73%;
  padding: 2rem;
}
.menu__side_open {
  left: 0;
}
.menu__side-links {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-top: 1.5rem;
}
.menu__side-link {
  font-family: var(--merriweather);
  cursor: pointer;
  color: rgba(var(--white));
  font-size: 1.25rem;
  line-height: 1.6;
  font-weight: 400;
  padding: 0.5rem 0;
}
.menu__side-social {
  display: flex;
  gap: 1rem;
}
.menu__side-social a {
  display: flex;
}
.menu__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}`, "",{"version":3,"sources":["webpack://./src/components/Menu/styles.scss"],"names":[],"mappings":"AAEI;EACE,oCAAA;AADN;AAIE;EACE,cAAA;EACA,eAAA;EACA,6BAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;AAFJ;AAII;EACE,yDAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,uBAAA;EACA,uCAAA;AAFN;AAIM;EACE,gBAAA;AAFR;AAOE;EACE,eAAA;EACA,aAAA;EACA,8BAAA;EACA,sBAAA;EACA,eAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;EACA,uCAAA;EACA,oBAAA;EACA,UAAA;EACA,aAAA;AALJ;AAOI;EACE,OAAA;AALN;AAQI;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;AANN;AASI;EACE,gCAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AAPN;AAUI;EACE,aAAA;EACA,SAAA;AARN;AAUM;EACE,aAAA;AARR;AAaE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAXJ","sourcesContent":[".menu {\n  &_white {\n    .menu__button-item {\n      background-color: rgba(var(--white));\n    }\n  }\n  &__button {\n    display: block;\n    cursor: pointer;\n    transform-origin: 1rem 0.7rem;\n    float: left;\n    outline: 0;\n    border: 0;\n    background: none;\n\n    &-item {\n      transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n      display: block;\n      width: 1.1875rem;\n      height: 0.125rem;\n      margin-bottom: 0.25rem;\n      border-radius: 0.125rem;\n      background-color: rgba(var(--grey-800));\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n    }\n  }\n\n  &__side {\n    position: fixed;\n    display: flex;\n    justify-content: space-between;\n    flex-direction: column;\n    z-index: 999999;\n    top: 0;\n    bottom: 0;\n    left: -100%;\n    background-color: rgba(var(--grey-800));\n    transition: all 0.5s;\n    width: 73%;\n    padding: 2rem;\n\n    &_open {\n      left: 0;\n    }\n\n    &-links {\n      display: flex;\n      flex-direction: column;\n      gap: 1.5rem;\n      margin-top: 1.5rem;\n    }\n\n    &-link {\n      font-family: var(--merriweather);\n      cursor: pointer;\n      color: rgba(var(--white));\n      font-size: 1.25rem;\n      line-height: 1.6;\n      font-weight: 400;\n      padding: 0.5rem 0;\n    }\n\n    &-social {\n      display: flex;\n      gap: 1rem;\n\n      a {\n        display: flex;\n      }\n    }\n  }\n\n  &__footer {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
